import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import { ToggleSwitchProps } from './ToggleSwitch.types'
import useInput from '../useInput'
import InputWrapper from '../InputWrapper/InputWrapper'

const ToggleSwitch: React.FC<ToggleSwitchProps> = (props) => {
    const { size, switchLabel, insideLabel } = props
    const context = useInput({ ...props }, 'boolean')
    const { value, isDisabled, onChange } = context
    const onSwitchRef = useRef(null)
    const offSwitchRef = useRef(null)
    const [switchToggleWidth, setSwitchToggleWidth] = useState(0)

    useEffect(() => {
        if (onSwitchRef.current || offSwitchRef.current) {
            let width = 0
            if (value === true) {
                width = onSwitchRef.current.getBoundingClientRect().width
            } else {
                width = offSwitchRef.current.getBoundingClientRect().width
            }
            setSwitchToggleWidth(width)
        }
    }, [onSwitchRef, offSwitchRef, value])

    const classNames = () => {
        const c = ['r-toggle-switch-container']

        if (value) {
            c.push('r-state-on')
        }
        if (insideLabel) {
            c.push('r-toggle-inside-label')
        }

        if (size) {
            c.push(`r-size-${props.size}`)
        }

        if (isDisabled) {
            c.push('r-state-disabled')
        }

        return c.join(' ')
    }

    const handleToggle = (e) => {
        onChange(!value)
    }

    const variants = {
        on: { left: 'auto', right: '2px' },
        off: { left: '2px', right: 'auto' },
    }

    const renderSwitchLabel = () => {
        if (typeof switchLabel === 'string') {
            return switchLabel
        }
        return value ? switchLabel['on'] : switchLabel['off']
    }

    return (
        <InputWrapper {...context} className={'r-toggle-switch-input-wrapper'}>
            <div data-testid='ToggleSwitch' className={classNames()}>
                <div className={'r-toggle-switch'} onClick={handleToggle}>
                    {insideLabel ? (
                        <div ref={offSwitchRef} className={'r-switch-inside-item'}>
                            {switchLabel['off']}
                        </div>
                    ) : (
                        ''
                    )}
                    {insideLabel ? (
                        <div ref={onSwitchRef} className={'r-switch-inside-item'}>
                            {switchLabel['on']}
                        </div>
                    ) : (
                        ''
                    )}
                    <motion.div
                        style={{ width: insideLabel ? switchToggleWidth + 'px' : null }}
                        className='r-toggle-circle'
                        variants={variants}
                        initial='off'
                        animate={value ? 'on' : 'off'}
                    ></motion.div>

                    <input type='checkbox' checked={value} onChange={handleToggle} style={{ display: 'none' }} />
                </div>
                {switchLabel && !insideLabel ? <div className={'r-switch-label'}>{renderSwitchLabel()}</div> : null}
            </div>
        </InputWrapper>
    )
}

export default ToggleSwitch
